export default __webpack_public_path__ + "static/scientist11-4da28fafdad64e65ebeaa9e2eb6171bc.jpg";